export default "__VITE_PUBLIC_ASSET__1f6f97db__"